/*---------------------------
| Action Types (TOC)
---------------------------*/
export const actionTypes = {
    MS_ADD_MESSAGES: "MS: addMessages",
    MS_REMOVE_MESSAGE: "MS: removeMessage"
};
